import gql from "graphql-tag";

export default gql`
  fragment IndicatorFields on IndicatorDefinition {
    objectId
    kind
    category
    dataSource
    vertical
    numberFormatOptions {
      style
      notation
      compactDisplay
      minimumFractionDigits
      maximumFractionDigits
      minimumSignificantDigits
      maximumSignificantDigits
      minimumIntegerDigits
    }
    documentation {
      languageCode
      name
      abbreviation
      description
    }
    columnTheme {
      backgroundColor
      textColor
    }
    viewerCanSee
  }
`;
